import { createAsyncThunk } from '@reduxjs/toolkit';

export const disconnectSalesChannel = createAsyncThunk(
  'salesChannels/disconnectSalesChannel',
  async ({ salesChannelId }, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.setup.resetSalesChannel({ salesChannelId });
      return { salesChannelId, ...data };
    } catch (error) {
      Logger.error(
        new Error('Disconnect sales channel failed'),
        { error, salesChannelId },
        ['ConnectShopifyChDisconnectFailed', { salesChannelId: String(salesChannelId) }],
      );
      throw error;
    }
  },
);
